<section class="our-mission-area ptb-100">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="our-mission-content">
          @for (Content of ourMissionContent; track Content) {
            <div class="content">
              <h2>{{Content.title}}</h2>
              <p>{{Content.paragraphText1}}</p>
              <ul class="features-list">
                @for (List of featuresList; track List) {
                  <li><i class="{{List.icon}}"></i> {{List.title}}</li>
                }
              </ul>
              <p>{{Content.paragraphText2}}</p>
              <a routerLink="/{{Content.defaultBtnLink}}" class="default-btn"><i class="{{Content.defaultBtnIcon}}"></i>{{Content.defaultBtnText}}<span></span></a>
            </div>
          }
        </div>
      </div>

      <div class="col-lg-6 col-md-12">
        @for (Image of ourMissionImage; track Image) {
          <div class="our-mission-image">
            <img [src]="Image.img" alt="Data science leadership training">
            <div class="shape"><img src="assets/img/our-mission/shape1.png" alt=""></div>
          </div>
        }
      </div>
    </div>
  </div>
</section>